import { render, staticRenderFns } from "./SurfaceTreatment.vue?vue&type=template&id=13c94ae8&"
import script from "./SurfaceTreatment.vue?vue&type=script&lang=js&"
export * from "./SurfaceTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports